import React from 'react'

interface State {
    user?: any
    changeUser: (user: any) => void
    initLoad: () => void
    changeLanguage?: any
}
const UserContext = React.createContext<State>({ user: null, changeUser: () => { }, initLoad: () => { } })
export default UserContext